import {
  CourseRouteTypeEnum,
  getRideRouteType,
  isMlPathRoutingWaypoint,
  isRideGreyed,
  isStationRouteWaypointStation,
  RideStationPanelMode,
  type IRideDto,
  type IStationInfo,
} from "@ryde/shared";

/** Every station and waypoint row can be deleted, area waypoints included, except on a shuttle ride. */
export const isRideStationDeleteAvailable = ({
  rideDto,
  station,
  mode,
}: {
  rideDto: Partial<IRideDto> | undefined;
  station: IStationInfo | undefined;
  mode: RideStationPanelMode | undefined;
}): boolean => {
  if (isRideGreyed(rideDto)) {
    return false;
  }

  if (
    rideDto?.courseId &&
    getRideRouteType(rideDto) === CourseRouteTypeEnum.Shuttle
  ) {
    return false;
  }

  if (station && isStationRouteWaypointStation(station)) {
    return !(
      mode === RideStationPanelMode.GRID_PANEL &&
      isMlPathRoutingWaypoint(station)
    );
  }

  return true;
};
